// shadi-arts-portfolio Firebase\client\src\pages\AdminDashboard.jsx

import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminLogin from '../components/Admin/AdminLogin';
import AdminLayout from '../components/Admin/AdminLayout';

const AdminDashboard = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="admin-loading">Loading...</div>;
  }
  
  if (!user) {
    return <AdminLogin />;
  }
  
  return <AdminLayout />;
};

export default AdminDashboard;